// ParentRegistration.jsx
import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaUserPlus, FaUser, FaPhone, FaEnvelope, FaLock, FaCheckCircle } from "react-icons/fa";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import toast from "react-hot-toast";
import ApiEndpoints, {BASE_URL} from './commonComponents/ApiEndpoints'

const ParentRegistration = () => {
  // const navigate = useNavigate()
  // const [formData, setFormData] = useState({
  //   parentName: "",
  //   phoneNumber: "",
  //   email: "",
  //   password: "",
  // });

  // const [submittedData, setSubmittedData] = useState(null);
  // const [showPassword, setShowPassword] = useState(false);

  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData({ ...formData, [name]: value });
  // };

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   setSubmittedData(formData);
  //   setFormData({
  //     parentName: "",
  //     phoneNumber: "",
  //     email: "",
  //     password: "",
  //   });
  // };

  // const togglePasswordVisibility = () => setShowPassword(!showPassword);


 const navigate = useNavigate();
  const [formData, setFormData] = useState({
    parentName: "",
    phoneNumber: "",
    email: "",
    password: "",
  });

  const [submittedData, setSubmittedData] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const togglePasswordVisibility = () => setShowPassword(!showPassword);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const payload = {
        name: formData.parentName,
        phone_number: formData.phoneNumber,
        email: formData.email,
        password: formData.password,
      };

      const response = await axios.post(
        BASE_URL+"/add/guardian",
        payload,
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      if (response.status === 200 || response.status === 201) {
        setSubmittedData({ ...formData }); // Show what user entered
        setFormData({
          parentName: "",
          phoneNumber: "",
          email: "",
          password: "",
        });
        toast.success(response.data.message)
        setTimeout(()=>{
          navigate("/Login")
        },3000)
      } 
       else {
      // Dynamically get the first error from any field
      const errors = response.data.errors;
      if (errors) {
        const firstKey = Object.keys(errors)[0];
        toast.error(errors[firstKey][0]);
      } else {
        toast.error(response.data.message || "Validation failed");
      }
    }
  } catch (err) {
      
     console.error(err);

    // Handle API errors dynamically
    const errors = err.response?.data?.errors;
    if (errors) {
      const firstKey = Object.keys(errors)[0];
      toast.error(errors[firstKey][0]);
    } else {
      toast.error(err.response?.data?.message || "Something went wrong");
    }
    } finally {
      setLoading(false);
    }
  };


  return (
   <>
   
    <div className="container my-5">
      <div className="row justify-content-center">
        <div className="col-lg-8">
          <div className="glass-card card-hover">
            <div className="header-bg text-center" style={{fontSize:"15px"}}>
               <div className="floating-icon ">
                <FaUserPlus style={{fontSize:20}}/>
             </div>
              <h3 style={{fontSize:"20px"}} className="mb-2 ">
               Parent Registration</h3>
              <p className="mb-0" > 
                Register your details to stay connected with your child's education
              </p>
            </div>

            <div className="card-body p-4 p-md-5 text-start">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6 mb-4">
                    <label className="form-label fw-semibold">Parent Name</label>
                    <div className="input-icon position-relative">
                      <FaUser className="position-absolute top-50 translate-middle-y ms-3 text-secondary" />
                      <input
                        type="text"
                        className="form-control ps-5"
                        placeholder="Enter parent's full name"
                        name="parentName"
                        value={formData.parentName}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>

                  <div className="col-md-6 mb-4">
                    <label className="form-label fw-semibold">Phone Number</label>
                    <div className="input-icon position-relative">
                      <FaPhone className="position-absolute top-50 translate-middle-y ms-3 text-secondary" />
                      <input
                        type="tel"
                        className="form-control ps-5"
                        placeholder="Enter phone number"
                        name="phoneNumber"
                        value={formData.phoneNumber}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>

                  <div className="col-md-6 mb-4">
                    <label className="form-label fw-semibold">Email Address</label>
                    <div className="input-icon position-relative">
                      <FaEnvelope className="position-absolute top-50 translate-middle-y ms-3 text-secondary" />
                      <input
                        type="email"
                        className="form-control ps-5"
                        placeholder="Enter email address"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>

                  <div className="col-md-6 mb-4">
                    <label className="form-label fw-semibold">Password</label>
                    <div className="input-icon position-relative">
                      <FaLock className="position-absolute top-50 translate-middle-y ms-3 text-secondary" />
                      <input
                        type={showPassword ? "text" : "password"}
                        className="form-control ps-5"
                        placeholder="Create a secure password"
                        name="password"
                        value={formData.password}
                        onChange={handleChange}
                        required
                      />
                      <span
                        className="position-absolute top-50 translate-middle-y end-0 me-3 text-secondary"
                        style={{ cursor: "pointer" }}
                        onClick={togglePasswordVisibility}
                      >
                        {showPassword ? "Hide" : "Show"}
                      </span>
                    </div>
                  </div>
                </div>

                {/* <div className="d-grid mt-2">
                  <button type="submit" className="btn btn-dark btn-lg">
                    <FaUserPlus className="me-2" />
                    Register Now
                  </button>
                </div> */}
                
                {error && <p className="text-danger">{error}</p>}

                <div className="d-grid mt-2">
                  <button
                    type="submit"
                    className="btn btn-dark btn-lg"
                    disabled={loading}
                  >
                    {loading ? "Registering..." : <><FaUserPlus className="me-2" /> Register Now</>}
                  </button>
                </div>

                  <p style={{marginTop:"1rem"}}>
                    Have an account? <span
                    style={{ cursor: 'pointer', letterSpacing: '1px' }}
                    className="text-end fw-semibold text-decoration-underline"
                    onClick={()=>navigate("/Login")}>Please login</span>
                  </p>

              </form>
                {/* {submittedData && (
                <div className="submitted-data mt-4">
                  <h5 className="mb-3 text-pink">
                    <FaCheckCircle className="me-2 text-pink" />
                    Registration Successful!
                  </h5>
                  <div className="row">
                    <div className="col-md-6">
                      <p>
                        <span className="data-highlight">Parent Name:</span>{" "}
                        {submittedData.parentName}
                      </p>
                      <p>
                        <span className="data-highlight">Phone:</span>{" "}
                        {submittedData.phoneNumber}
                      </p>
                    </div>
                    <div className="col-md-6">
                      <p>
                        <span className="data-highlight">Email:</span>{" "}
                        {submittedData.email}
                      </p>
                      <p>
                        <span className="data-highlight">Password:</span>{" "}
                        {submittedData.password}
                      </p>
                    </div>
                  </div>
                </div>
              )} */}


            </div>
          </div>
        </div>
      </div>
    </div>
    <style>
      {`
      :root {
  --primary: #4361ee;
  --secondary: #3a0ca3;
  --accent: #f72585;
  --light: #f8f9fa;
  --dark: #212529;
}

body {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.glass-card {
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  
}

.header-bg {
  background: linear-gradient(135deg, var(--dark), var(--secondary));
  padding: 5px;
  color: white;
  position: relative;
  overflow: hidden;
}

.header-bg::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0) 60%);
  transform: rotate(30deg);
}

.form-control {
  border-radius: 10px;
  padding: 12px 20px;
  border: 2px solid #e6e6e6;
  transition: all 0.3s;
}

.form-control:focus {
  border-color: var(--primary);
  box-shadow: 0 0 0 0.25rem rgba(67, 97, 238, 0.25);
}

.floating-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  background: linear-gradient(135deg, var(--primary), var(--secondary));
  color: white;
  border-radius: 50%;
  margin-bottom: 15px;
  box-shadow: 0 4px 10px rgba(67, 97, 238, 0.3);
}

.card-hover {
  transition: transform 0.3s, box-shadow 0.3s;
}

.card-hover:hover {
  transform: translateY(-5px);
  box-shadow: 0 12px 25px rgba(0, 0, 0, 0.15);
}

.submitted-data {
  background: rgba(255, 255, 255, 0.8);
  border-radius: 15px;
  padding: 20px;
  margin-top: 25px;
  border-left: 5px solid var(--accent);
}

.data-highlight {
  color: var(--secondary);
  font-weight: 600;
}

.bg-light-blue {
  background: rgba(67, 97, 238, 0.1);
}

`}
    </style>
    </>
  );
};

export default ParentRegistration;
